import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import MarketShell from '../components/market/MarketShell';
import { useDeliveredConfig } from '../lib/marketMode';
import { MIX, PICK_TABS, PICKS_POOL, categoryPicks, mixPicks } from '../lib/homePicks';
import { CardRow, HOME2_T } from './MarketHome';

// «عرض الكل» of one «اختيارات التجار» tab (owner, 2026-11-02): today's pool —
// the same products, in the same order, the home page draws its eight from
// (homePicks: kept for the day, shared).
export default function MarketPicks({ lang = 'ar', user, exchangeRates }) {
  const { tab: key } = useParams();
  const nav = useNavigate();
  usePageTitle('market', lang);
  const tab = PICK_TABS.find((t) => t.key === key);
  const dcfg = useDeliveredConfig();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!tab || !dcfg) return undefined;
    let alive = true;
    const load = tab.key === MIX ? mixPicks({ dcfg, rates: exchangeRates, size: PICKS_POOL }) : categoryPicks(tab.key, { dcfg, rates: exchangeRates });
    load.then((r) => { if (alive) setRows(r); }).catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, [tab, dcfg, exchangeRates]);
  const c = HOME2_T[lang] || HOME2_T.ar;
  return (
    <MarketShell lang={lang} user={user}>
      <div className="mk-wrap" style={{ paddingTop: 16, paddingBottom: 48 }}>
        <div className="mk-crumbs" style={{ marginTop: 0 }}>
          <button type="button" onClick={() => nav('/market')}>{lang === 'ar' ? 'السوق' : 'Market'}</button><span aria-hidden="true">›</span><span>{c.picksHead}</span>
        </div>
        <h1 className="mk-home-h2" style={{ fontSize: 22 }}>{tab ? (lang === 'ar' ? tab.ar : tab.en) : c.picksHead}</h1>
        {!tab ? <p className="mk-empty">—</p> : rows === null ? <div className="mk-skel" style={{ height: 300 }} />
          : <CardRow rows={rows} lang={lang} user={user} exchangeRates={exchangeRates} max={rows.length} />}
      </div>
    </MarketShell>
  );
}
